{
  "brand": "BidNova Auctions",
  "browse": "瀏覽拍賣",
  "trends": "市場趨勢",
  "community": "社群",
  "watchlist": "追蹤清單",
  "wantList": "徵求清單",
  "myBids": "我的出價",
  "orders": "訂單",
  "sell": "賣出",
  "signIn": "登入",
  "join": "註冊",
  "signOut": "登出",
  "account": "帳戶",
  "accountMenu": "{name} 的帳戶選單",
  "dashboard": "總覽",
  "accountProfile": "帳戶與個人檔案",
  "sellerDashboard": "賣家中心",
  "myAuctions": "我的拍賣",
  "orderCentre": "訂單中心",
  "collection": "收藏",
  "notifications": "通知",
  "admin": "管理後台",
  "language": "語言",
  "changeLanguage": "切換語言",
  "footer": {
    "tagline": "英國首屈一指的鑑定卡與集換式卡牌交易平台。以英鎊即時競投，全程由 Stripe 保障，並完全符合英國 GDPR 規範。",
    "marketplace": "交易平台",
    "browseAuctions": "瀏覽拍賣",
    "marketTrends": "市場趨勢",
    "sellCard": "賣出卡牌",
    "community": "社群",
    "communityHub": "社群中心",
    "articles": "新聞與文章",
    "events": "英國卡展",
    "dealers": "商戶名錄",
    "categories": "熱門分類",
    "legal": "法律資訊",
    "terms": "條款及細則",
    "privacy": "私隱政策",
    "cookies": "Cookie 政策",
    "buyerTerms": "買家條款",
    "sellerAgreement": "賣家協議",
    "refunds": "退款與爭議",
    "cookieSettings": "Cookie 設定",
    "contact": "聯絡我們",
    "registered": "於英格蘭及威爾斯註冊",
    "trusted": "安全可靠",
    "stripeSecured": "Stripe 保障",
    "gdpr": "GDPR",
    "cards": "信用卡及 Apple Pay",
    "rights": "© 2026 BidNova Auctions。版權所有。",
    "governed": "適用英格蘭及威爾斯法律 · 價格以英鎊（£）顯示"
  },
  "home": "主頁",
  "tradingCards": "集換卡",
  "collectibles": "收藏品",
  "fashion": "時尚服飾",
  "sealedProducts": "未開封產品",
  "accessories": "配件",
  "sellAnItem": "出售物品",
  "searchPlaceholder": "搜尋卡牌、公仔、服飾及更多…"
}
